import { googleMapsLoader } from 'context/GeoLocationContext/googleMapsLoader';

export async function googleMapLoader() {
  if (typeof window === 'undefined') {
    throw new Error('googleMapLoader called outside the browser');
  }

  if (window.google?.maps) {
    return window.google.maps;
  }

  if ((window as any).__googleMapsBlocked) {
    throw new Error('Google Maps is unavailable in this region');
  }

  await googleMapsLoader.ensureLoaded();

  if (!window.google?.maps) {
    throw new Error('Google Maps script did not load');
  }

  return window.google.maps;
}
